// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Activity__Wrapper_1J5Rf","Title":"Activity__Title_3rtZz"};